export default __webpack_public_path__ + "static/media/scree-shots.cb6397c1.png";